// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import useFilteredVariantTraits from "@store/Modules/client-framework/src/Common/Hooks/useFilteredVariantTraits";
import { getVariantChildrenDataView } from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";

const useProductFilteredVariantTraits = (product: ProductModel | undefined, returnDisabled?: boolean) => {
    const variantChildren = useAppSelector(state => getVariantChildrenDataView(state, product?.id).value);

    const variantSelection = product?.childTraitValues?.reduce((result, traitValue) => {
        result[traitValue.styleTraitId] = traitValue.id;

        return result;
    }, {} as Dictionary<string>);

    return useFilteredVariantTraits(
        product?.variantTraits || [],
        variantChildren || [],
        variantSelection || {},
        returnDisabled,
    );
};

export default useProductFilteredVariantTraits;
